import React from 'react';
//import biglogo from '../assets/WizardEmoji2.png';
import biglogo from '../assets/SendUSDC.gif';

import { Box, Heading, Text } from 'rimble-ui';

export default function IntroBox() {
	return (
		<div>
			<div style={{ display: 'flex-direction' }}>
				<Box>
					<img
						style={{
							textAlign: 'center',
							display: 'block',
							margin: 'auto',
							marginTop: '-60px',
							width: '100%',
							backgroundColor: 'transparent'
						}}
						src={biglogo}
						alt="Biglogo"
					/>
				</Box>
			</div>
			<div
				style={{
					margin: 'auto',
					marginTop: '-80px',
					display: 'flex-direction',
					width: '100%',
					marginLeft: '10px'
				}}
			>
				<Heading>Send USDC</Heading>
				<br />
				<Text>Send it at your own risk on Web Browser with Metamask enabled.</Text>
				<Text>
					Available in <b>Mainnet</b> and<b> Ropsten</b> only.
				</Text>
				<Text style={{ color: 'yellow' }}> Sending USDC with ease.</Text>
			</div>
		</div>
	);
}
